/**
 * 100원 프로모션 혜택 대상이나 혜택 받지 않고 2개월차 정상 결제를 할 경우
 * onShowBillingPopup 에서 사용하는 product id 값을 none promotion 의 productCode 필드 값으로 대체 한 후 object 리턴
 * @params payloads
 * @returns {object} | undefined
 */
export const getReplacedPromotionProduct = (payloads = {}) => {
  const voucherInfo = payloads?.voucherInfo ?? {}
  const { nonePromotionProductInfo: target, productInfo: source } = voucherInfo

  if (!target) return payloads
  if (!source) return undefined

  const productId = target?.productCode

  return {
    ...payloads,
    voucherInfo: {
      ...payloads.voucherInfo,
      productInfo: { ...source, productid: productId },
    },
  }
}
